import { defineAsyncComponent } from 'vue'
export default {
  "store-simple": defineAsyncComponent(() => import("/opt/jenkins/workspace/Tenda/layouts/store-simple.vue").then(m => m.default || m)),
  store: defineAsyncComponent(() => import("/opt/jenkins/workspace/Tenda/layouts/store.vue").then(m => m.default || m)),
  "user-center": defineAsyncComponent(() => import("/opt/jenkins/workspace/Tenda/layouts/user-center.vue").then(m => m.default || m)),
  website: defineAsyncComponent(() => import("/opt/jenkins/workspace/Tenda/layouts/website.vue").then(m => m.default || m))
}